// Tiny fuzzy matcher: positive score iff every needle char appears in order
// in the haystack; closer characters score higher.

export function fuzzyScore(needle, hay) {
	if (!needle) return 1;
	const n = needle.toLowerCase();
	const h = hay.toLowerCase();
	let score = 0;
	let hi = 0;
	for (const ch of n) {
		const idx = h.indexOf(ch, hi);
		if (idx === -1) return 0;
		score += 1 / (idx - hi + 1);
		hi = idx + 1;
	}
	return score;
}

export function fuzzyFilter(query, items, getText) {
	if (!query) return items;
	return items
		.map((item) => ({ item, score: fuzzyScore(query, getText(item)) }))
		.filter((x) => x.score > 0)
		.sort((a, b) => b.score - a.score)
		.map((x) => x.item);
}
